interface IconProps {
  color?: string
}

export function Bank({ color }: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      aria-hidden="true"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6668 10.2C17.1454 10.2 17.5334 9.81201 17.5334 9.33337C17.5334 8.85472 17.1454 8.4667 16.6668 8.4667H15.3334C14.8548 8.4667 14.4668 8.85472 14.4668 9.33337C14.4668 9.81201 14.8548 10.2 15.3334 10.2H16.6668Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M13.9464 5.73529C15.1749 4.85777 16.8253 4.85777 18.0538 5.73529L25.8372 11.2948C26.1438 11.5138 26.2737 11.9058 26.1588 12.2646C26.0438 12.6233 25.7102 12.8667 25.3334 12.8667H22.8668V20.4921C23.4637 20.5463 24.0506 20.6868 24.609 20.9102L25.9891 21.4622C26.9218 21.8353 27.5335 22.7387 27.5335 23.7433C27.5335 25.1001 26.4335 26.2 25.0767 26.2H6.92357C5.56673 26.2 4.4668 25.1001 4.4668 23.7433C4.4668 22.7387 5.07841 21.8353 6.01115 21.4622L7.39128 20.9102C7.94962 20.6868 8.53654 20.5463 9.13346 20.4921V12.8667H6.66678C6.29002 12.8667 5.95643 12.6233 5.84145 12.2646C5.72648 11.9058 5.85646 11.5138 6.16304 11.2948L13.9464 5.73529ZM21.1335 20.4667V12.8667H18.8668V20.4667H21.1335ZM14.8668 12.8667V20.4667H17.1335V12.8667H14.8668ZM13.1335 20.4667L13.1335 12.8667H10.8668V20.4667H13.1335ZM17.0463 7.14576C16.4205 6.69872 15.5797 6.69872 14.9539 7.14576L9.37118 11.1334H22.629L17.0463 7.14576ZM9.6939 22.2C9.12566 22.2 8.56263 22.3085 8.03502 22.5195L6.65489 23.0716C6.38023 23.1814 6.20013 23.4475 6.20013 23.7433C6.20013 24.1428 6.52403 24.4667 6.92357 24.4667H25.0767C25.4762 24.4667 25.8001 24.1428 25.8001 23.7433C25.8001 23.4475 25.62 23.1814 25.3454 23.0716L23.9652 22.5195C23.4376 22.3085 22.8746 22.2 22.3064 22.2H9.6939Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
